import ContactForm from "@/components/base/ContactForm";
import ContactInfo from "@/components/base/ContactInfo";

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-4xl font-bold mb-3">
          Demandez un devis gratuit
        </h2>
        <p className="text-brand-text text-base md:text-lg mb-8">
          Remplissez le formulaire ci-dessous, nous vous recontactons sous 24h.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8 lg:gap-10 min-w-0">
          <div className="lg:col-span-3">
            <ContactForm
              page="Haguenau"
              subject="Nouveau lead Dépan'Volets — Haguenau"
              variant="wide"
              showTitle={false}
            />
          </div>
          <div className="lg:col-span-2">
            <ContactInfo variant="light" />
          </div>
        </div>
      </div>
    </section>
  );
}